import { L10n, loadCldr } from '@syncfusion/ej2-base';
import intl from 'react-intl-universal';
import frNumberData from '@syncfusion/ej2-cldr-data/main/fr-CH/numbers.json';
import frtimeZoneData from '@syncfusion/ej2-cldr-data/main/fr-CH/timeZoneNames.json';
import frGregorian from '@syncfusion/ej2-cldr-data/main/fr-CH/ca-gregorian.json';
import frNumberingSystem from '@syncfusion/ej2-cldr-data/supplemental/numberingSystems.json';

/**
 * Loads localization configuration for Syncfusion Schedule component
 * This function configures the schedule and recurrence editor text for different locales
 * and loads the required CLDR data for French locale
 */
export const loadScheduleLocalization = (): void => {
  // Load CLDR data for French locale

  // Load L10n configuration
  L10n.load({
    'en-US': {
      schedule: {
        newEvent: intl.get('SCHEDULE.ADD_NEW_EVENT'),
        today: intl.get('SCHEDULE.TODAY'),
        week: intl.get('SCHEDULE.WEEK'),
        month: intl.get('SCHEDULE.MONTH'),
        start: intl.get('SCHEDULE.SCHEDULE_START'),
        end: intl.get('SCHEDULE.SCHEDULE_END'),
        allDay: intl.get('SCHEDULE.SCHEDULE_ALL_DAY'),
        editSeries: intl.get('SCHEDULE.EDIT_SERIES'),
        deleteSeries: intl.get('SCHEDULE.DELETE_SERIES'),
        edit: intl.get('SCHEDULE.EDIT'),
        delete: intl.get('SCHEDULE.DELETE'),
      },
      recurrenceeditor: {
        repeat: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT'),
        repeatEvery: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_EVERY'),
        on: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_ON'),
        weeks: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_ON_WEEKS'),
        days: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_ON_DAYS'),
        months: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_ON_MONTHS'),
        never: intl.get(
          'SCHEDULE.EVENTS.DETAILS_SECTION.RECURRENCE_TYPES.NEVER'
        ),
        daily: intl.get(
          'SCHEDULE.EVENTS.DETAILS_SECTION.RECURRENCE_TYPES.DAILY'
        ),
        weekly: intl.get(
          'SCHEDULE.EVENTS.DETAILS_SECTION.RECURRENCE_TYPES.WEEKLY'
        ),
        monthly: intl.get(
          'SCHEDULE.EVENTS.DETAILS_SECTION.RECURRENCE_TYPES.MONTHLY'
        ),
        until: intl.get('SCHEDULE.RECURRENCE_EDITOR.UNTIL'),
        count: intl.get('SCHEDULE.RECURRENCE_EDITOR.COUNT'),
      },
    },
    'fr-CH': {
      calendar: { today: intl.get('SCHEDULE.TODAY') },
      datetimepicker: { today: intl.get('SCHEDULE.TODAY') },
      datepicker: { today: intl.get('SCHEDULE.TODAY') },
      schedule: {
        newEvent: intl.get('SCHEDULE.ADD_NEW_EVENT'),
        today: intl.get('SCHEDULE.TODAY'),
        week: intl.get('SCHEDULE.WEEK'),
        month: intl.get('SCHEDULE.MONTH'),
        start: intl.get('SCHEDULE.SCHEDULE_START'),
        end: intl.get('SCHEDULE.SCHEDULE_END'),
        allDay: intl.get('SCHEDULE.SCHEDULE_ALL_DAY'),
        saveButton: intl.get('SAVE'),
        cancelButton: intl.get('CANCEL'),
        editSeries: intl.get('SCHEDULE.EDIT_SERIES'),
        deleteSeries: intl.get('SCHEDULE.DELETE_SERIES'),
        edit: intl.get('SCHEDULE.EDIT'),
        delete: intl.get('SCHEDULE.DELETE'),
      },
      recurrenceeditor: {
        repeat: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT'),
        repeatEvery: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_EVERY'),
        on: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_ON'),
        weeks: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_ON_WEEKS'),
        days: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_ON_DAYS'),
        months: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_ON_MONTHS'),
        never: intl.get(
          'SCHEDULE.EVENTS.DETAILS_SECTION.RECURRENCE_TYPES.NEVER'
        ),
        daily: intl.get(
          'SCHEDULE.EVENTS.DETAILS_SECTION.RECURRENCE_TYPES.DAILY'
        ),
        weekly: intl.get(
          'SCHEDULE.EVENTS.DETAILS_SECTION.RECURRENCE_TYPES.WEEKLY'
        ),
        monthly: intl.get(
          'SCHEDULE.EVENTS.DETAILS_SECTION.RECURRENCE_TYPES.MONTHLY'
        ),
        until: intl.get('SCHEDULE.RECURRENCE_EDITOR.UNTIL'),
        count: intl.get('SCHEDULE.RECURRENCE_EDITOR.COUNT'),
        onDay: intl.get('SCHEDULE.RECURRENCE_EDITOR.DAY'),
        first: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_ON_FIRST'),
        second: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_ON_SECOND'),
        third: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_ON_THIRD'),
        fourth: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_ON_FOURTH'),
        last: intl.get('SCHEDULE.RECURRENCE_EDITOR.REPEAT_ON_LAST'),
      },
    },
  });
  loadCldr(frNumberData, frtimeZoneData, frGregorian, frNumberingSystem);
};
